export const AFFILIATE_COLLECTIONS = Object.freeze({
  applications: "affiliateApplications",
  affiliates: "affiliates",
  codes: "affiliateCodes",
  commissions: "affiliateCommissions",
  payouts: "affiliatePayouts",
});

export const AFFILIATE_APPLICATION_STATUSES = Object.freeze({
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
});

export const AFFILIATE_STATUSES = Object.freeze({
  approved: "approved",
  suspended: "suspended",
  rejected: "rejected",
});

export const AFFILIATE_COMMISSION_STATUSES = Object.freeze({
  pending: "pending",
  approved: "approved",
  voided: "voided",
  paid: "paid",
});

export const AFFILIATE_PAYOUT_STATUSES = Object.freeze({
  draft: "draft",
  pending: "pending",
  paid: "paid",
  cancelled: "cancelled",
});

export const DEFAULT_AFFILIATE_COURSE_SETTINGS = Object.freeze({
  affiliateEnabled: false,
  affiliateCommissionPercent: 10,
});

export function normalizeAffiliateCommissionPercent(value, fallback = 10) {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(100, Math.max(0, Math.round(n * 100) / 100));
}

export function buildDefaultAffiliateApplication({ userId = "" } = {}) {
  return {
    userId,
    status: AFFILIATE_APPLICATION_STATUSES.pending,
    profile: {
      displayName: "",
      phoneNumber: "",
      publicBio: "",
    },
    contact: {
      email: "",
      lineId: "",
      facebookUrl: "",
    },
    bankAccount: {
      bankName: "",
      accountName: "",
      accountNumber: "",
      accountNumberLast4: "",
    },
    qrCode: {
      imageUrl: "",
      storagePath: "",
      updatedAt: null,
    },
    message: "",
    createdAt: null,
    updatedAt: null,
  };
}

export function buildDefaultAffiliateProfile({ userId = "", code = "" } = {}) {
  return {
    userId,
    code,
    status: AFFILIATE_STATUSES.approved,
    profile: {
      displayName: "",
      publicBio: "",
    },
    contact: {
      email: "",
      phoneNumber: "",
      lineId: "",
    },
    bankAccount: {
      bankName: "",
      accountName: "",
      accountNumber: "",
      accountNumberLast4: "",
    },
    qrCode: {
      imageUrl: "",
      storagePath: "",
      updatedAt: null,
    },
    createdAt: null,
    updatedAt: null,
  };
}

export function buildDefaultAffiliateCode({ code = "", affiliateId = "", affiliateUserId = "" } = {}) {
  return {
    code,
    affiliateId,
    affiliateUserId,
    status: AFFILIATE_STATUSES.approved,
    createdAt: null,
    updatedAt: null,
  };
}

export function buildDefaultAffiliateCommission() {
  return {
    affiliateId: "",
    affiliateUserId: "",
    affiliateCode: "",
    enrollId: "",
    courseId: "",
    courseTitle: "",
    buyerUserId: "",
    grossAmount: 0,
    commissionPercent: DEFAULT_AFFILIATE_COURSE_SETTINGS.affiliateCommissionPercent,
    commissionAmount: 0,
    status: AFFILIATE_COMMISSION_STATUSES.pending,
    payoutStatus: "unpaid",
    createdAt: null,
    updatedAt: null,
  };
}

export function buildDefaultAffiliatePayout() {
  return {
    affiliateId: "",
    affiliateUserId: "",
    monthKey: "",
    status: AFFILIATE_PAYOUT_STATUSES.draft,
    commissionCount: 0,
    totalCommissionAmount: 0,
    paidAt: null,
    paidByUid: "",
    note: "",
    createdAt: null,
    updatedAt: null,
  };
}
